"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var SvgMacOssvg = function (props) { return ((0, jsx_runtime_1.jsxs)("svg", __assign({ fill: "current", height: 13, width: 13, xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { clipRule: "evenodd", d: "M9.228.999c.082 1.622-.73 2.765-2.31 2.886.055-1.678.938-2.526 2.31-2.886z", fillRule: "evenodd" }), (0, jsx_runtime_1.jsx)("path", { d: "M10.298 7.238c0-1.011.53-1.899 1.326-2.4-.71-.745-1.395-1.22-2.589-1.098-.71.074-1.293.478-1.924.481-1.19.008-2.057-.739-3.223-.288-1.098.424-1.786 1.722-1.876 2.982-.155 2.16.908 4.647 2.069 5.628.204.173.61.387.865.433.696.126 1.124-.323 1.877-.433 1.024-.15 1.763.552 2.645.433 1.37-.183 2.024-2.077 2.494-3.156a2.835 2.835 0 0 1-1.664-2.582z" })] }))); };
exports.default = SvgMacOssvg;
